// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"150":"050d761570a5ecae864d","156":"b2a6bda2c0b00f994250"}[chunkId] + ".js";
};